import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetMetadaServiceCaseQuery} from '@dms/api/workshop';

export function useTaskRelationServiceCase(serviceCaseId: string) {
  const {
    data: serviceCase,
    isLoading: isServiceCaseLoading,
    isError: isServiceCaseError,
  } = useGetMetadaServiceCaseQuery({serviceCaseId}, {skip: isNilOrEmpty(serviceCaseId)});

  return {
    serviceCase,
    customerId: serviceCase?.customerId,
    isServiceCaseDraft: serviceCase?.state === 'DRAFT',
    isLoading: isServiceCaseLoading,
    isError: isServiceCaseError,
  };
}
